import React, { useState } from 'react'
import { exportComponentAsJPEG } from 'react-component-export-image'
import Header from '../components/header'

import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
  Select,
  Tooltip
} from '@chakra-ui/core'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { DebounceInput } from 'react-debounce-input'
import Boards from '../components/Boards'
import { setGlobalState, setStorageState, useGlobalState } from '../store'
import { BoardWrapper } from './styled.js'
import { ButtonGroup } from '@material-ui/core'
dayjs.extend(customParseFormat)
export default function Dashboard(props) {
  const [userTypes, setUserTypes] = useGlobalState('userTypes')
  setGlobalState('pageClass', 'users')
  const [viewOptions, setviewOptions] = useGlobalState('viewOptions')
  const ref = React.useRef(null)

  const options = {
    filterType: 'dropdown'
  }
  return (
    <div className={'wrapper'}>
      <Header>
        {/* <button onClick={() => props.socket.emit('page', 'planning')}>
          Isto é o que está a acontecer hoje
        </button> */}
        <Flex
          alignItems={['center']}
          display={{ base: 'block', md: 'flex' }}
          justifyItems={[
            'flex-start',
            'flex-start',
            'flex-start',
            'space-between'
          ]}
          justifyContent={['space-between']}
          flexDirection={['column', 'column', 'row', 'row']}
          fontSize={{ base: '.8em', md: '1em' }}
        >
          <Flex
            gap={4}
            alignItems={'center'}
            opacity={['0', '0', '1', '1']}
            // display={['none', 'none', 'flex', 'flex']}
            textAlign={'left'}
          >
            <h1>
              Planeamento{' '}
              <a
                onClick={() => {
                  exportComponentAsJPEG(ref)
                }}
              >
                <span
                  style={{ fontSize: '.6em' }}
                  className={`icon-printer icons`}
                />
              </a>
            </h1>
          </Flex>
          <Flex
            flexDirection={['column', 'column', 'row', 'row']}
            alignItems={'flex-end!important'}
            justifyContent={'flex-end'}
            flexWrap={'wrap'}
            boxShadow={'0 0 5px rgba(0,0,0,.1)'}
            p={'.5em'}
            borderRadius={'0 0 0 5px'}
            background={'#fff'}
            position={'fixed'}
            top={0}
            right={0}
            zIndex={10}
          >
            <Box mr={'.5em'}>
              <InputGroup size="sm">
                <InputLeftAddon
                  textAlign={'center'}
                  cursor={'pointer'}
                  padding={'1em .5em'}
                  children={'‹'}
                  borderRadius={'3px 0 0 3px'}
                  onClick={event =>
                    setviewOptions({
                      ...viewOptions,
                      date: dayjs(viewOptions.date)
                        .add(-1, viewOptions.displayType || 'week')
                        .format('YYYY-MM-DD')
                    })
                  }
                  fontWeight={'bold'}
                  // _hover={{ color: 'red' }}
                />
                <Input
                  padding={'.5em .5em'}
                  fontSize={'.8em'}
                  onChange={event =>
                    setviewOptions({
                      ...viewOptions,
                      date: event.target.value
                    })
                  }
                  type={'date'}
                  value={dayjs(viewOptions.date).format('YYYY-MM-DD')}
                />
                <InputLeftAddon
                  textAlign={'center'}
                  cursor={'pointer'}
                  padding={'1em .5em'}
                  borderRadius={'0 3px 3px 0'}
                  children={'›'}
                  onClick={event =>
                    setviewOptions({
                      ...viewOptions,
                      date: dayjs(viewOptions.date)
                        .add(1, viewOptions.displayType || 'week')
                        .format('YYYY-MM-DD')
                    })
                  }
                  fontWeight={'bold'}
                  // _hover={{ color: 'red' }}
                />
              </InputGroup>
            </Box>
            <Flex
              gap={4}
              alignItems={'center'}
              display={['none', 'none', 'flex', 'flex']}
            >
              <DebounceInput
                style={{
                  padding: '.5em',
                  border: '1px solid #E2E8F0',
                  borderRadius: '5px 0 0 5px',
                  with: '20%',
                  fontSize: '12px'
                }}
                placeholder={'Pesquisar'}
                type={'text'}
                value={viewOptions.search || ''}
                minLength={1}
                debounceTimeout={500}
                onChange={event =>
                  setStorageState('viewOptions', {
                    ...viewOptions,
                    search: event.target.value
                  })
                }
              />
              {/* <DebounceInput
                style={{
                  padding: '.5em',
                  border: '1px solid #E2E8F0',
                  with: '20%',
                  borderRadius: 5
                }}
                placeholder={'Pesquisar Projetos'}
                type={'text'}
                value={viewOptions.searchProject || ''}
                minLength={1}
                debounceTimeout={500}
                onChange={event =>
                  setStorageState('viewOptions', {
                    ...viewOptions,
                    searchProject: event.target.value
                  })
                }
              /> */}

              {/* <Input
                padding={'.5em .5em'}
                placeholder={'pesquisar projetos'}
                onChange={event =>
                  setStorageState('viewOptions', {
                    ...viewOptions,
                    search: event.target.value
                  })
                }
                type={'text'}
                value={viewOptions.search || ''}
              /> */}
              <Box>
                {userTypes && (
                  <Select
                    onChange={event => {
                      return setStorageState('viewOptions', {
                        ...viewOptions,
                        type: event.target.value
                      })
                    }}
                    placeholder="Todos"
                    size={'sm'}
                    w={'150px'}
                    borderRadius={'0 5px 5px 0'}
                    color={'#ccc'}
                    value={viewOptions.type}
                  >
                    {/* <option value={'project'}> Projeto</option> */}

                    {userTypes
                      .sort((a, b) => (b.name < a.name ? 1 : -1))
                      .map(
                        t =>
                          t.status === 1 && (
                            <option value={t._id}> {t.name}</option>
                          )
                      )}
                  </Select>
                )}
              </Box>
            </Flex>
            <Box marginLeft={'.5em'} fontSize={'.8em'}>
              <ButtonGroup size={'sm'}>
                <Button
                  variantColor={
                    viewOptions.displayType === 'day' ? 'red' : 'gray'
                  }
                  color={viewOptions.displayType === 'day' ? '#fff' : '#000'}
                  variant={
                    viewOptions.displayType === 'day' ? 'solid' : 'outline'
                  }
                  onClick={() =>
                    setStorageState('viewOptions', {
                      ...viewOptions,
                      displayType: 'day'
                    })
                  }
                >
                  <Tooltip label="Vista de dia">
                    <span className={`icon-book-open icons`} />
                  </Tooltip>
                </Button>
                <Button
                  variantColor={
                    viewOptions.displayType === 'week' ? 'red' : 'gray'
                  }
                  color={viewOptions.displayType === 'week' ? '#fff' : '#000'}
                  variant={
                    viewOptions.displayType === 'week' ? 'solid' : 'outline'
                  }
                  onClick={() =>
                    setStorageState('viewOptions', {
                      ...viewOptions,
                      displayType: 'week'
                    })
                  }
                >
                  <Tooltip label="Vista de Semanal">
                    <span className={`icon-list icons`} />
                  </Tooltip>
                </Button>
                <Button
                  variantColor={viewOptions.showOnlyTransfers ? 'red' : 'gray'}
                  color={viewOptions.showOnlyTransfers ? '#fff' : '#000'}
                  variant={viewOptions.showOnlyTransfers ? 'solid' : 'outline'}
                  onClick={() =>
                    setStorageState('viewOptions', {
                      ...viewOptions,
                      showOnlyTransfers: !viewOptions.showOnlyTransfers
                    })
                  }
                >
                  <Tooltip label="Ver as transferências">
                    <span className={`icon-organization icons`} />
                  </Tooltip>
                </Button>
                <Button
                  variantColor={
                    viewOptions.viewType === 'users' ||
                    viewOptions.viewType === 'all'
                      ? 'red'
                      : 'gray'
                  }
                  color={
                    viewOptions.viewType === 'users' ||
                    viewOptions.viewType === 'all'
                      ? '#fff'
                      : '#000'
                  }
                  variant={
                    viewOptions.viewType === 'users' ||
                    viewOptions.viewType === 'all'
                      ? 'solid'
                      : 'outline'
                  }
                  onClick={() => {
                    let newView = 'users'
                    if (viewOptions.viewType === 'users') {
                      newView = 'global'
                    } else if (viewOptions.viewType === 'resources') {
                      newView = 'all'
                    }
                    setStorageState('viewOptions', {
                      ...viewOptions,
                      viewType: newView
                    })
                  }}
                >
                  <Tooltip label="Ver pessoas">
                    <span className={`icon-people icons`} />
                  </Tooltip>
                </Button>
                <Button
                  variantColor={
                    viewOptions.viewType === 'resources' ||
                    viewOptions.viewType === 'all'
                      ? 'red'
                      : 'gray'
                  }
                  color={
                    viewOptions.viewType === 'resources' ||
                    viewOptions.viewType === 'all'
                      ? '#fff'
                      : '#000'
                  }
                  variant={
                    viewOptions.viewType === 'resources' ||
                    viewOptions.viewType === 'all'
                      ? 'solid'
                      : 'outline'
                  }
                  onClick={() => {
                    let newView = 'resources'
                    if (viewOptions.viewType === 'resources') {
                      newView = 'global'
                    } else if (viewOptions.viewType === 'users') {
                      newView = 'all'
                    }
                    setStorageState('viewOptions', {
                      ...viewOptions,
                      viewType: newView
                    })
                  }}
                >
                  <Tooltip label="Ver recursos">
                    <span className={`icon-wrench icons`} />
                  </Tooltip>
                </Button>
              </ButtonGroup>
            </Box>
          </Flex>
        </Flex>
      </Header>

      <BoardWrapper ref={ref}>
        <Boards />
      </BoardWrapper>
    </div>
  )
}
